<template>
    <div :style="!vertical ? 'width: 100%; height: 1px; min-height: 1px' : 'height: 100%; width: 1px; min-width: 1px'" :class="color">

    </div>
</template>

<script>
export default {
    props: {
        vertical: {
            default: false,
            type: Boolean
        },
        color: {
            default: 'grey',
            type: String
        }
    }
}
</script>

<style scoped>

</style>